import React from 'react';
import useTranslation from '../../../../hooks/translation/useTranslation';

function NotFound({ rides }) {
  const { trans } = useTranslation();
  const notFound = !rides?.departureRides?.length && !rides?.returnRides?.length;
  return notFound && (
    <div className="flex justify-center items-center bg-white rounded-2xl h-[260px]">
      {trans('no_rides_found')}
    </div>
  );
}

export default NotFound;
